import React from "react";

export function LeadsHelpVideo() {
  return (
      <section style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid rgba(0, 212, 255, 0.2)' }}>
        <h3 style={{ color: '#00D4FF', fontSize: '1rem', fontWeight: 600, marginBottom: 16, textTransform: 'uppercase', letterSpacing: 1 }}>Vídeo de ajuda</h3>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: 800, margin: '0 auto', borderRadius: 12, border: '1px solid rgba(0, 212, 255, 0.3)' }}>
          <iframe
            title="Como usar Leads"
            src="https://www.loom.com/embed/ea04ff2704de411c92e7638eb86a2669"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            frameBorder="0"
            allow="fullscreen"
            allowFullScreen
          />
        </div>
      </section>
  );
}
